import { ToastService } from '../../shared/components/toast/services/toast.service';
import { EnumKnowledgeErrorCode } from '../enums/knowledge-error-code.enum';
import { EnumHITLErrorCode } from '../interfaces/hitl.interface';
import { ChatSessionSlice } from './chat-sessions.store';
import { ConversationMessageProjection } from './conversation-message-projection';
import { KnowledgeCacheService } from './knowledge-cache.service';

const KNOWLEDGE_ERROR_MESSAGES: Record<EnumKnowledgeErrorCode, string> = {
  [EnumKnowledgeErrorCode.DOCUMENT_NOT_FOUND]:
    'Este documento não está mais disponível. A lista foi atualizada.',
  [EnumKnowledgeErrorCode.DOCUMENT_UNAVAILABLE]:
    'Este documento está sendo processado e ainda não pode ser consultado.',
  [EnumKnowledgeErrorCode.KNOWLEDGE_UNAVAILABLE]:
    'Não foi possível consultar seus documentos agora. Tente novamente em instantes.'
};

const INVALIDATES_KNOWLEDGE_CACHE: EnumKnowledgeErrorCode[] = [
  EnumKnowledgeErrorCode.DOCUMENT_NOT_FOUND,
  EnumKnowledgeErrorCode.DOCUMENT_UNAVAILABLE
];

/** Apresenta falhas do domínio e invalida o cache quando necessário. */
export class ConversationErrorPresenter {
  constructor(
    private state: ChatSessionSlice,
    private projection: ConversationMessageProjection,
    private toastService: ToastService,
    private knowledgeCache: KnowledgeCacheService
  ) {}

  present(errorCode?: string, messageId?: string): void {
    if (
      errorCode === EnumHITLErrorCode.STALE_INTERRUPT_ID ||
      errorCode === EnumHITLErrorCode.NO_PENDING_INTERRUPT
    ) {
      this.state.interrupt.next(null);
      this.state.isTyping.next(false);
      this.toastService.error('Esta aprovação não está mais disponível.');
      return;
    }

    if (errorCode === EnumHITLErrorCode.GENERATION_IN_PROGRESS) {
      this.state.isTyping.next(false);
      this.toastService.error(
        'Já existe um processamento em andamento nesta conversa.'
      );
      return;
    }

    const knowledgeMessage =
      KNOWLEDGE_ERROR_MESSAGES[errorCode as EnumKnowledgeErrorCode];
    if (knowledgeMessage) {
      if (
        INVALIDATES_KNOWLEDGE_CACHE.includes(
          errorCode as EnumKnowledgeErrorCode
        )
      ) {
        this.knowledgeCache.invalidate();
      }
      this.projection.showAgentError(knowledgeMessage, messageId);
      return;
    }

    this.projection.showAgentError(
      'Desculpe, ocorreu um erro ao processar sua mensagem. Tente novamente.',
      messageId
    );
  }
}
